import { render, staticRenderFns } from "./CashDetails.vue?vue&type=template&id=32180785&scoped=true"
import script from "./CashDetails.vue?vue&type=script&lang=js"
export * from "./CashDetails.vue?vue&type=script&lang=js"
import style0 from "./CashDetails.vue?vue&type=style&index=0&id=32180785&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32180785",
  null
  
)

export default component.exports